import React, { useEffect, useState } from "react";
import { Link, NavLink, useLocation } from "react-router-dom";
import { jwtDecode } from "jwt-decode";
import styles from "./DashboardTopNav.module.css";

type Role = "admin" | "provider" | "patient";

function detectRole(): Role | null {
  const idToken = localStorage.getItem("idToken");
  if (!idToken) return null;
  try {
    const decoded: any = jwtDecode(idToken);
    const groups: string[] = decoded["cognito:groups"] || [];
    if (groups.includes("admin")) return "admin";
    if (groups.includes("provider") || groups.includes("Provider")) return "provider";
    if (groups.includes("Patient") || groups.includes("patient")) return "patient";
  } catch {
    return null;
  }
  return null;
}

export default function DashboardTopNav() {
  const location = useLocation();
  const [tokenRole, setTokenRole] = useState<Role | null>(() => detectRole());

  useEffect(() => {
    setTokenRole(detectRole());
  }, [location.pathname]);

  const isPatientPreview = location.pathname === "/patient-dashboard/preview";
  const isProviderPreview = location.pathname === "/dashboard/preview";

  const role: Role | null = tokenRole
    ? tokenRole
    : isPatientPreview
      ? "patient"
      : isProviderPreview
        ? "provider"
        : null;

  const appHome =
    isPatientPreview
      ? "/patient-dashboard/preview"
      : isProviderPreview
        ? "/dashboard/preview"
        : role === "admin"
          ? "/admin"
          : role === "patient"
          ? "/patient-dashboard"
          : role === "provider"
            ? "/dashboard"
            : "/";

  const patientDash = isPatientPreview ? "/patient-dashboard/preview" : "/patient-dashboard";
  const patientSettings = isPatientPreview ? "/login" : "/profile/settings";
  const providerDash = isProviderPreview ? "/dashboard/preview" : "/dashboard";
  const profilePath =
    isPatientPreview || isProviderPreview ? "/login" : "/profile";

  return (
    <header className={styles.bar}>
      <div className={styles.inner}>
        <Link to={appHome} className={styles.brand}>
          <img src="/mrehabIcon.png" alt="" width={32} height={32} />
          <span className={styles.brandText}>mRehab</span>
          <span className={styles.badge}>
            {isPatientPreview || isProviderPreview
              ? "Preview"
              : role === "admin"
                ? "Admin"
                : role === "provider"
                ? "Provider"
                : role === "patient"
                  ? "Member"
                  : "Account"}
          </span>
        </Link>

        <nav className={styles.nav} aria-label="App">
          {role === "admin" ? (
            <>
              <NavLink
                to="/admin"
                className={({ isActive }) =>
                  `${styles.link} ${isActive ? styles.linkActive : ""}`
                }
                end
              >
                Access requests
              </NavLink>
              <NavLink
                to={profilePath}
                className={({ isActive }) =>
                  `${styles.link} ${isActive ? styles.linkActive : ""}`
                }
              >
                Profile
              </NavLink>
            </>
          ) : role === "provider" ? (
            <>
              <NavLink
                to={providerDash}
                className={({ isActive }) =>
                  `${styles.link} ${isActive ? styles.linkActive : ""}`
                }
                end
              >
                Overview
              </NavLink>
              <NavLink
                to={profilePath}
                className={({ isActive }) =>
                  `${styles.link} ${isActive ? styles.linkActive : ""}`
                }
              >
                Profile
              </NavLink>
            </>
          ) : role === "patient" ? (
            <>
              <NavLink
                to={patientDash}
                className={({ isActive }) =>
                  `${styles.link} ${isActive ? styles.linkActive : ""}`
                }
                end
              >
                My progress
              </NavLink>
              <NavLink
                to={patientSettings}
                className={({ isActive }) =>
                  `${styles.link} ${isActive ? styles.linkActive : ""}`
                }
              >
                Settings
              </NavLink>
              <NavLink
                to={profilePath}
                className={({ isActive }) =>
                  `${styles.link} ${isActive ? styles.linkActive : ""}`
                }
              >
                Profile
              </NavLink>
            </>
          ) : (
            <NavLink
              to="/login"
              className={({ isActive }) =>
                `${styles.link} ${isActive ? styles.linkActive : ""}`
              }
            >
              Sign in
            </NavLink>
          )}
          <NavLink
            to="/privacy"
            className={({ isActive }) => `${styles.link} ${isActive ? styles.linkActive : ""}`}
          >
            Privacy
          </NavLink>
        </nav>

        <div className={styles.right}>
          <Link to="/" className={styles.mainSite}>
            Main site
          </Link>
        </div>
      </div>
    </header>
  );
}
